import React from "react";
import ReactDOM from "react-dom";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import 'rc-notification/assets/index.css';
import "react-confirm-alert/src/react-confirm-alert.css";

import 'antd/dist/antd.css';
import 'sweetalert2/src/sweetalert2.scss';

// import "./site.scss";
import "./index.css";
import './assets/libs/css/all.css'
import 'bootstrap/dist/css/bootstrap.min.css';


import './assets/scss/main.scss'

// import 'bootstrap-4-react/dist/bootstrap-4-react';

import './translations/i18n';
import App from "./App";

ReactDOM.render(
    // <React.StrictMode>
        <App />
    // </React.StrictMode>
    ,
    document.getElementById("root")
);
